import React from 'react';

// Modern (jjfv2) header / hero / footer
import HeaderV2 from '../../components/headerV2/HeaderV2';
import FooterV2 from '../../components/footerV2/FooterV2';
import AboutHero from '../../components/aboutHero/AboutHero';
import BlogSidebar from './BlogSidebar';

// CSS imoports
import '../AboutUsPage/aboutV2.css';
import './blogs.css';

// Image imports
import Blog1Img from "./../../images/blogs/when_gratitude_finds_blog.webp";
import { Helmet } from 'react-helmet';

export default function WhenGratitudeFinds() {
    return (
        <>
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700;800&display=swap"
                    rel="stylesheet"
                />

                {/* Basic Meta Tags */}
                <title>When Gratitude Finds Its Way Back | JJF India</title>
                <meta name="description" content="At JJFIndia, we believe service is a shared pause between lives. Explore our story of quiet connection and food distribution at Sankatmochan Temple." />
                <meta name="keywords" content="JJFIndia, food donation drive Varanasi, Sankatmochan Temple Varanasi, Jainam Jivika Foundation, leprosy support India, reverse gratitude, humanitarian service Uttar Pradesh" />
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://jjfindia.com/our-bulletin/when-gratitude-finds" />

                {/* Open Graph */}
                <meta property="og:title" content="When Gratitude Finds Its Way Back | JJF India" />
                <meta property="og:description" content="At JJFIndia, we believe service is a shared pause between lives. Explore our story of quiet connection and food distribution at Sankatmochan Temple." />
                <meta property="og:url" content="https://jjfindia.com/our-bulletin/when-gratitude-finds" />

                {/* Twitter Cards */}
                {/* <meta name="twitter:card" content={metadata.twitter?.card} /> */}
                <meta name="twitter:title" content="When Gratitude Finds Its Way Back | JJF India" />
                <meta name="twitter:description" content="At JJFIndia, we believe service is a shared pause between lives. Explore our story of quiet connection and food distribution at Sankatmochan Temple." />
            </Helmet>
            
            <div className="jjfv2">
                <HeaderV2 />
                <AboutHero
                    eyebrow="Our Bulletin"
                    title="Blogs"
                    crumbs={[{ label: 'Home', to: '/' }, { label: 'Blogs' }]}
                />
            </div>
            <main className="page_content">
                    <div style={{paddingBottom: "60px", paddingTop: "60px"}} className="container">
                        <div className='single-blog-container' >
                            <div className="blog-article">
                                <h1>When Gratitude Finds Its Way Back</h1>
                                <div>
                                    <img src={Blog1Img} alt='blog' />
                                </div>
                                <div style={{display: "flex", alignContent: "flex-end", width: "100%"}}>
                                    <span style={{ width:"100%", textAlign: "right", paddingTop: "16px", paddingBottom: "16px" }}>10 November, 2023</span>
                                </div>
                                <div>
                                    <h2 className='single-blog-sub-heading' >From the person who receives, to the person who gives.</h2>
                                    <p>We are taught to recognise service by the thank-you that follows it - a nod, a smile, a brief moment of acknowledgement that confirms our effort mattered. Yet, every so often, life reverses this order. The gratitude does not come at the end. It appears quietly at the beginning, and it belongs to the one who thought they were there to give.</p>
                                    <p>Consider a simple, familiar moment. You help a stranger lift a heavy bag onto a bus. They thank you, of course - but what stays with you is not their gratitude. It is the brief connection, the shared pause, the sense that for a moment, two lives crossed without demand or expectation. These exchanges are small, but they have weight.</p>
                                    <p><strong>Something similar unfolded during our recent Food Donation Drive on 25th Dec at Sankatmochan Temple, Varanasi , Uttar Pradesh</strong></p>
                                    <p>We arrived with <strong>fifty boxes</strong> of snack food, carefully packed and thoughtfully organised. Everything had been planned to ensure the process ran smoothly. From a logistical perspective, the day was a success. Yet what stayed with us had little to do with organisation or numbers.</p>
                                    <p>We spent time with people affected by leprosy, and the pace of the day changed almost immediately. The distribution of food was unhurried. Conversations followed naturally. There were moments of silence that felt comfortable rather than awkward. What was shared went beyond what was carried in our hands.</p>
                                    <h2 className='single-blog-sub-heading' >What stood out most was the trust extended to us.</h2>
                                    <p>Trust to sit alongside.</p>
                                    <p>Trust to speak openly.</p>
                                    <p>Trust to be present without explanation.</p>
                                    <p>There was no sense of pity in these interactions. Instead, there was dignity - steady, unspoken, and deeply rooted. The resilience we encountered did not announce itself loudly. It existed in lived experience, in acceptance, and in the quiet strength of continuing daily life without complaint.</p>
                                    <h2 className='single-blog-sub-heading' >We came believing we would offer support. Instead, we found ourselves learning.</h2>
                                    <p>Learning that presence matters more than efficiency.</p>
                                    <p>Learning that listening is a form of respect.</p>
                                    <p>Learning that service, when done with sincerity, is never one-sided.</p>
                                    <p>Two volunteers, Devansh Sonkar and Rahul Verma, joined us during the drive and contributed with care and attentiveness. Their involvement reinforced a simple truth:</p>
                                    <p><strong>meaningful service depends as much on intention as it does on action.</strong></p>
                                    <p>So If you have ever felt that even a small act of help matters , you are already halfway there.</p>
                                    <p><strong>Service does not require wealth.</strong></p>
                                    <p><strong>It only requires intention.</strong> And one intention can make a real difference.</p>
                                </div>
                            </div>
                            <div>
                                <BlogSidebar />
                            </div>
                        </div>                    
                    </div>
                </main>
                <div className="jjfv2">
                    <FooterV2 />
                </div>
        </>
    );
}